module.exports = __webpack_public_path__ + "static/media/signage-indoor-img78.005efd0b.jpg";